import React from 'react';
import DishCard from './DishCard';

export default function CategorySection({ dishes, cart, onUpdateQuantity }) {
    if (!dishes || dishes.length === 0) return null;
    return (
        <div className="space-y-3">
            {dishes.map(dish => (
                <DishCard
                    key={dish.id}
                    dish={dish}
                    quantity={cart[dish.id] || 0}
                    onUpdateQuantity={(qty, event) => onUpdateQuantity(dish.id, qty, event, dish)}
                />
            ))}
        </div>
    );
}

